"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var React = tslib_1.__importStar(require("react"));
var classnames_1 = tslib_1.__importDefault(require("classnames"));
var rc_dropdown_1 = tslib_1.__importDefault(require("rc-dropdown"));
var config_provider_1 = require("../config-provider");
var DirectionRight_1 = require("../Icons/DirectionRight");
var reactNode_1 = require("../util/reactNode");
var types_1 = require("../util/types");
var dropdown_button_1 = tslib_1.__importDefault(require("./dropdown-button"));
var Placements = (0, types_1.tuple)('topLeft', 'topCenter', 'topRight', 'bottomLeft', 'bottomCenter', 'bottomRight');
var Dropdown = function (props) {
    var _a, _b;
    var _c = React.useContext(config_provider_1.ConfigContext), getContextPopupContainer = _c.getPopupContainer, getPrefixCls = _c.getPrefixCls, direction = _c.direction;
    var getTransitionName = function () {
        var _a = props.placement, placement = _a === void 0 ? '' : _a, transitionName = props.transitionName;
        if (transitionName !== undefined) {
            return transitionName;
        }
        if (placement.indexOf('top') >= 0) {
            return 'slide-down';
        }
        return 'slide-up';
    };
    var renderOverlay = function (prefixCls) {
        // rc-dropdown already can process the function of overlay, but we have check logic here.
        // So we need render the element to check and pass back to rc-dropdown.
        var overlay = props.overlay;
        var overlayNode;
        if (typeof overlay === 'function') {
            overlayNode = overlay();
        }
        else {
            overlayNode = overlay;
        }
        overlayNode = React.Children.only(typeof overlayNode === 'string' ? React.createElement("span", null, overlayNode) : overlayNode);
        var overlayProps = overlayNode.props;
        // menu cannot be selectable in dropdown defaultly
        // menu should be focusable in dropdown defaultly
        var _a = overlayProps.selectable, selectable = _a === void 0 ? false : _a, _b = overlayProps.focusable, focusable = _b === void 0 ? true : _b;
        var expandIcon = (React.createElement("span", { className: "".concat(prefixCls, "-menu-submenu-arrow") },
            React.createElement(DirectionRight_1.DirectionRight, { className: "".concat(prefixCls, "-menu-submenu-arrow-icon") })));
        var fixedModeOverlay = typeof overlayNode.type === 'string'
            ? overlayNode
            : (0, reactNode_1.cloneElement)(overlayNode, {
                mode: 'vertical',
                selectable: selectable,
                focusable: focusable,
                expandIcon: expandIcon,
            });
        return fixedModeOverlay;
    };
    var getPlacement = function () {
        var placement = props.placement;
        if (placement !== undefined) {
            return placement;
        }
        return direction === 'rtl' ? 'bottomRight' : 'bottomLeft';
    };
    var arrow = props.arrow, customizePrefixCls = props.prefixCls, children = props.children, trigger = props.trigger, disabled = props.disabled, getPopupContainer = props.getPopupContainer, overlayClassName = props.overlayClassName;
    var prefixCls = getPrefixCls('dropdown', customizePrefixCls);
    var child = React.Children.only(children);
    var dropdownTrigger = (0, reactNode_1.cloneElement)(child, {
        className: (0, classnames_1.default)("".concat(prefixCls, "-trigger"), (_a = {},
            _a["".concat(prefixCls, "-rtl")] = direction === 'rtl',
            _a), child.props.className),
        disabled: disabled,
    });
    var overlayClassNameCustomized = (0, classnames_1.default)(overlayClassName, (_b = {},
        _b["".concat(prefixCls, "-rtl")] = direction === 'rtl',
        _b));
    var triggerActions = disabled ? [] : trigger;
    var alignPoint;
    if (triggerActions && triggerActions.indexOf('contextMenu') !== -1) {
        alignPoint = true;
    }
    return (React.createElement(rc_dropdown_1.default, tslib_1.__assign({ arrow: arrow, alignPoint: alignPoint }, props, { overlayClassName: overlayClassNameCustomized, prefixCls: prefixCls, getPopupContainer: getPopupContainer || getContextPopupContainer, transitionName: getTransitionName(), trigger: triggerActions, overlay: function () { return renderOverlay(prefixCls); }, placement: getPlacement() }), dropdownTrigger));
};
Dropdown.Button = dropdown_button_1.default;
Dropdown.defaultProps = {
    mouseEnterDelay: 0.15,
    mouseLeaveDelay: 0.1,
};
exports.default = Dropdown;
//# sourceMappingURL=dropdown.js.map